/**
 * Checker Plus for Gmail — desktop notifications and inbox management
 *
 * Its web-accessible resources are all origin-scoped rather than exposed to every site.
 * options.html and contribute.html are matched only to jasonsavard.com (the vendor's own
 * site) plus a few payment origins, and css/tabletView.css is matched only to
 * mail.google.com. None use `use_dynamic_url`, so they are static — but genuinely
 * unreachable from anywhere outside their scoped origins.
 *
 * So this extension IS detectable, but only from jasonsavard.com. From any other origin
 * a negative result proves nothing — a limitation of where the probe runs, not evidence
 * about the browser.
 *
 * Manifest verified against version 36.3.1.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'oeopbcgkkoapgobdbedcemjljbihmemj';

export const checkerPlusForGmail: ExtensionDefinition = {
  id: ID,
  name: 'Checker Plus for Gmail™',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 900_000,
  requiredOrigin: 'https://jasonsavard.com',
  notes:
    'All WAR are origin-scoped, not on <all_urls>. options.html and contribute.html are ' +
    'exposed to jasonsavard.com, so only that site can detect it — a good example of ' +
    'the scoping mitigation. (css/tabletView.css is scoped separately to mail.google.com.)',
  signals: [
    {
      id: 'war-options-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch options.html — static, but only exposed to jasonsavard.com (and a few ' +
        'payment origins).',
      weight: 1,
      run: () => probeFetch(ID, 'options.html'),
    },
    {
      id: 'war-contribute-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch contribute.html — the other jasonsavard.com-scoped static resource, ' +
        'corroborating the identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'contribute.html'),
    },
  ],
};
